import { statusRevisaoConfig } from "@/mocks/cta";

interface TreeReviewBadgeProps {
  status: string;
  size?: "sm" | "md";
}

export default function TreeReviewBadge({ status, size = "sm" }: TreeReviewBadgeProps) {
  const cfg = statusRevisaoConfig[status] || { badge: "bg-background-100 text-foreground-500", label: status };
  const sizeClass = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return (
    <span className={`badge ${sizeClass} ${cfg.badge}`}>{cfg.label}</span>
  );
}